"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@dynamynd/core");

var actions_1 = require("../actions");

var state_1 = require("../state");

exports.viewReducer = function (state, action) {
  if (state === void 0) {
    state = state_1.initialUserState.view;
  }

  if (!action) return state;

  switch (action.type) {
    case actions_1.UserActionTypes.GET_USER_PROFILE:
    case actions_1.UserActionTypes.UPDATE_USER_PROFILE:
      return __assign(__assign({}, state), {
        fetching: true
      });

    case actions_1.UserActionTypes.SET_USER_PROFILE:
    case core_1.ActionTypes.DYNAMYND_ERROR:
      return __assign(__assign({}, state), {
        fetching: false
      });

    default:
      return state;
  }
};